import { NgModule } from "@angular/core";
import { WebSocketService } from "./websocket.service";

@NgModule({
    providers: [
        WebSocketService
    ]
})
export class WebSocketModule { }
